import _                                    from 'underscore';
import classNames                           from 'classnames';
import React, { FC, ReactNode, useContext } from 'react';
import { Modal, SemanticShorthandItem }     from 'semantic-ui-react';
import { DynamicComponentsContext }         from '../contexts';
import { SystemEvent }                      from '../../types/events';

export const pageModalElementId       = 'page-modal';
export const pageModalPortalElementId = 'page-modal-portal';

export interface ModalComponentProps {
	modalId?: string,
	portalId?: string,
	onClose?: PropsActionFunction,
	onOpen?: PropsActionFunction,
	onMount?: PropsActionFunction
	usePortal?: boolean,
	className?: string,
	children?: ReactNode,
	trigger?: ReactNode,
	header?: ReactNode,
	content?: ReactNode,
	closeOnDocumentClick?: boolean,
	closeOnDimmerClick?: boolean,
	actions?: SemanticShorthandItem<object>[],
	
	[ additionalProps: string ]: any
}

interface PropsActionFunction {
	( e: SystemEvent, data: object ): void
}

const defaultProps: ModalComponentProps = {
	onClose:              null,
	onOpen:               null,
	trigger:              null,
	header:               null,
	content:              null,
	closeOnDocumentClick: true,
	closeOnDimmerClick:   true,
	actions:              [
		{ key: 'close', content: 'Close', positive: true }
	]
}

const ModalComponent: FC<ModalComponentProps> = ( props ) => {
	
	let { modal: [ modal, modalActions ] } = useContext( DynamicComponentsContext );
	
	let handleHideModal: PropsActionFunction = ( e, data ) => {
		
		let { onClose } = ( modal.props as ModalComponentProps );
		
		modalActions.toggle();
		
		if( onClose && _.isFunction( onClose ) ) onClose( e, data );
		
	};
	
	let handleShowModal: PropsActionFunction = ( e, data ) => {
		
		let { onOpen } = ( modal.props as ModalComponentProps );
		
		if( onOpen && _.isFunction( onOpen ) ) onOpen( e, data );
		
	};
	
	let handleMountModal: PropsActionFunction = ( e, data ) => {
		
		let { content }            = modal,
		    { onMount, usePortal } = ( modal.props as ModalComponentProps );
		
		if( usePortal ){
			
			let modalNode = document.getElementById( pageModalElementId );
			
			/* provide an optional space for the portal to go into b/c
			* technically, the body could be filled via normal props.children */
			if( !content && modalNode ){
				modalNode
					.appendChild( document.createElement( "div" ) )
					.setAttribute( 'id', pageModalPortalElementId )
			}
		}
		
		if( onMount && _.isFunction( onMount ) ) onMount( e, data );
		
	};
	
	let { usePortal, className, children, actions, } = ( modal.props as ModalComponentProps );
	
	let modalProps: ModalComponentProps = {
		...props,
		..._.omit( modal.props, 'onOpen', 'onClose', 'onMount', 'usePortal' ),
		className: classNames( 'fade-in', className ),
		actions:   children ? null : actions,
		content:   modal.content,
		open:      modal.isOpen,
		onOpen:    handleShowModal,
		onClose:   handleHideModal,
		onMount:   handleMountModal,
	};
	
	return (
		( usePortal )
		? <Modal { ...modalProps } id={ pageModalElementId }>{ children }</Modal>
		: <Modal { ...modalProps } />
	);
};

ModalComponent.defaultProps = defaultProps;

export { ModalComponent as PageModal }
